var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "custom-dialog-header-container" }, [
    _c("header", { staticClass: "header" }, [
      _c("span", { staticClass: "header-title" }, [
        _vm._v(_vm._s(_vm.headerTitle)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }